<template>
    <v-list class="theme-back transparent" :class="sideClass(team)">
        <v-list-item v-for="i in itemCount" :key="'substitute_item_'+team+'_'+i"
                     :class="[playingClass(players, i-1), selectedClass(players, i-1), excludedClass(players, i-1), goalkeeperClass(players, i-1), backgroundClass(players, i-1)]">
            <PlayerSubstitute v-if="((gamedata.rule === 'STRAND' && i <= 10) || gamedata.rule === 'TEREM') && players[i-1]" :key="'substitute_'+team+'_'+(i-1)" :player="{...players[i-1]}" :gamefinished="gamefinished" :team="team" :started="started" :isMirrored="isMirrored" :playtime="playtime"/>
            <PlayerEntry v-else-if="gamedata.rule === 'TEREM' || (gamedata.rule === 'STRAND' && i <= 10)" :newPlayer="newPlayer" :substitute="true" :canEntryPlayer="canEntryPlayer"/>
            <PlayerSpace v-else/>
        </v-list-item>
        <PlayerPicker v-if="team && team !==''" :overlay="showPicker" :players="playerEntry" :team="team" :takenJerseys="takenJerseyNumbers" screen="substitute"/>
    </v-list>
</template>

<script>
    import PlayerSubstitute from "@/components/PlayerSubstitute";
    import PlayerEntry from "@/components/PlayerEntry";
    import PlayerSpace from "@/components/PlayerSpace";
    import PlayerPicker from "@/components/PlayerPicker";
    import CONSTANTS from '@/constants';
    import eventBus from '@/eventBus';

    import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
        name: 'PlayerListSubstitute',
        components: {
            PlayerSubstitute,
            PlayerEntry,
            PlayerSpace,
            PlayerPicker,
        },
        props: {
            persons: Array,
            itemCount: Number,
            team: String,
            started: Boolean,
            isMirrored: Boolean,
            playerEntry: Array,
            gamefinished: Boolean,
            canEntryPlayer: Boolean,
            playtime: Object,
            gamedata: Object,
        },
        data: function() {
            return {
                goalkeepers: [],
                showPicker: false,
            }
        },
        created() {
            let self = this;

            this.$busOn(CONSTANTS.ACTIONS.HIDEPICKER,function() {
                self.showPicker = false;
                eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false)
            });
        },
        methods: {
            newPlayer: function() {
                this.showPicker = true;
                eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, true);
            },
            sideClass: function(teamChar) {
                if(!this.isMirrored) {
                    return (teamChar === "A") ? "left-list" : "right-list";
                } else {
                    return (teamChar === "A") ? "right-list" : "left-list";
                }
            },
            playingClass(players, index) {
                return (players[index] && players[index].playing && !players[index].excluded) ? 'playing' : '';
            },
            selectedClass(players, index) {
                return (players[index] && players[index].selected) ? 'selectedPlayer' : '';
            },
            excludedClass(players, index) {
                return (players[index] && players[index].excluded) ? 'excluded' : '';
            },
            goalkeeperClass(players, index) {
                return (players[index] && players[index].goalkeeper) ? 'goalkeeper-player' : 'normal-player';
            },
            backgroundClass(players, index) {
                if(players[index]) {
                    if(players[index].excluded) {
                        return 'theme-excluded';
                    }

                    if (players[index].selected) {
                        return 'theme-selected-green';
                    }
                }

                return 'theme-background';
            },
        },
        computed: {
            players() {
                let self = this;
                let persons = [];
                self.goalkeepers = [];
                for (let person in self.persons) {
                    if(typeof self.persons[person] !== "undefined") {
                        persons.push(self.persons[person]);
                        if (self.persons[person] && self.persons[person].goalkeeper) {
                            self.goalkeepers.push(self.persons[person]);
                        }
                    }
                }

                if(persons.length) {
                    persons.sort(function(a,b){
                        return (a.jersey === b.jersey) ? 0 : (a.jersey < b.jersey) ? -1 : 1;
                    });

                    persons.sort(function(a,b){
                        return (a.goalkeeper === b.goalkeeper) ? 0 : a.goalkeeper ? -1 : 1;
                    });
                }

                return persons;
            },
            takenJerseyNumbers() {
                let jerseyList = [];

                this.players.forEach(player => {
                    if(player.jersey) {
                        jerseyList.push(player.jersey);
                    }
                });

                return jerseyList;
            },
        },
    }
</script>

<style scoped>
    .v-list {
        width: 100%;
        height: 100%;
        padding: 0;
        display: flex;
        flex-flow: column;
        justify-content: stretch;
        overflow: auto;
        scrollbar-width: thin;
    }

    .v-list.left-list {
        direction: rtl;
        /*align-items: flex-start;*/
        align-items: flex-end;
    }

    .v-list.right-list {
        align-items: flex-end;
    }

    .v-list-item {
        padding: 0;
        height: calc(6.25% - 0.5px);
        min-height: calc(6.25% - 0.5px);
        /*min-height: 36px;*/
        direction: ltr;
    }

    .v-list-item.playing {
        width: 100%;
    }

    .v-list-item.excluded {
        width: 100%;
    }

    .v-list-item:not(.playing):not(.excluded) {
        width: calc(100% - 45px);
    }

    .v-list-item.goalkeeper-player + .v-list-item.normal-player {
        margin-top: 8px;
    }

    .theme-selected-green.theme--light {
        background-color: #a6ffc3 !important;
    }

    .theme-selected-green.theme--dark {
        background-color: #23C373 !important;
    }
</style>

<style>
    .v-list.left-list .player-entry-substitute {
        border-right-width: 1px !important;
        flex-flow: row-reverse;
        flex-direction: row-reverse;
    }

    .v-list.right-list .player-entry-substitute {
        border-left-width: 1px !important;
    }

    .theme-selected-green.theme--light.playing.normal-player:not(.excluded) .stt-player-number {
        color: #000000 !important;
    }

    .theme-selected-green.theme--dark.playing.normal-player:not(.excluded) .stt-player-number {
        color: #ffffff !important;
    }

    .theme-selected-green.theme--light.playing.normal-player .player-playing:not(.player-excluded) {
        color: #000000 !important;
    }

    .theme-selected-green.theme--dark.playing.normal-player .player-playing:not(.player-excluded) {
        color: #ffffff !important;
    }
</style>
